import React from 'react';
import { Col, Row } from 'react-bootstrap';
import styles from '../SlideShow/slideShow.module.css';
import Img from 'gatsby-image';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from 'gatsby';
import { v4 as uuidv4 } from 'uuid';

const SlideShow = ({ products, title, bgColor, specialHandle }) => {
	const settings = {
		dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		initialSlide: 0,
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
					arrows: true
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					initialSlide: 2
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	};
	return (
		<section>
			<Row className={styles.section} style={{ backgroundColor: { bgColor } }}>
				<Col xs={12}>
					<h3 className={styles.title}>{title}</h3>
				</Col>
				<Col xs={12}>
					{specialHandle ? (
						<Slider {...settings}>
							{products.map((product) => (
								<Link to={`/${specialHandle}/${product.handle}`} className={styles.link} key={uuidv4()}>
									<Col className={styles.product}>
										{product.image ? (
											<Img
												fluid={product.image.localFile.childImageSharp.fluid}
												alt={product.title}
											/>
										) : (
											<Img
												fluid={product.images[0].localFile.childImageSharp.fluid}
												alt={product.title}
											/>
										)}

										<p className={styles.productTitle}>{product.title}</p>
										{product.priceRange && (
											<p className={styles.price}>
												€ {product.priceRange.minVariantPrice.amount}
											</p>
										)}
									</Col>
								</Link>
							))}
						</Slider>
					) : (
						<Slider {...settings}>
							{products.map((product) => (
								<Link to={`/collections/${product.handle}`} className={styles.link} key={uuidv4()}>
									<Col className={styles.product}>
										{product.image ? (
											<Img fluid={product.image.localFile.childImageSharp.fluid} />
										) : (
											<Img fluid={product.images[0].localFile.childImageSharp.fluid} />
										)}

										<p className={styles.productTitle}>{product.title}</p>
										{product.priceRange && (
											<p className={styles.price}>
												€ {product.priceRange.minVariantPrice.amount}
											</p>
										)}
									</Col>
								</Link>
							))}
						</Slider>
					)}
				</Col>
			</Row>
		</section>
	);
};

export default SlideShow;
